export const TOOLTIP_THROTTLE_TIME = 50;
